export default "__VITE_ASSET__CRl$fWs1__"